import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Comparison() {
  return <section aria-labelledby="comparison-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-51" data-mp="1l7e051w4x7h5">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-52" data-mp="1py46oigargdf">
        <div className="max-w-3xl" data-id="element-53" data-mp="1pzp20aafr3cc">
          <Eyebrow tone="rose" data-id="element-54" data-mp="1pzyr7vnnp6gz">Before vs. after</Eyebrow>
          <h2 id="comparison-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-55" data-mp="1uwfhowibvwx8">
            Stop improvising. <span className="text-amber" data-id="element-56" data-mp="23xdkjbh15ye8">Start teaching with a system.</span>
          </h2>
        </div>

        <div className="mt-10 grid gap-5 lg:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-57" data-mp="28x8g3sbr3c5m">
          <div className="rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-8" data-id="element-58" data-mp="9k49hf8u64tv">
            <p className="text-[11px] font-semibold uppercase tracking-label text-rose" data-id="element-59" data-mp="eiz3zeg61htt">
              Without the Arsenal
            </p>
            <ul className="mt-5 divide-y divide-night-600" data-id="element-60" data-mp="1m1qz9dv8zsd3">
              {comparisonRows.map(row => <li key={row.without} className="flex items-start gap-3 py-4 first:pt-0 last:pb-0" data-id="element-61" data-mp="1h979zjn778sg">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose" aria-hidden="true" data-id="element-62" data-mp="1d96wq2bu53mz" />
                  <span className="text-sm leading-relaxed text-cream-muted sm:text-base" data-id="element-63" data-mp="18adha4czn2k6">
                    {row.without}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-8" data-id="element-64" data-mp="20yhoiub7jnoz">
            <p className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-65" data-mp="1vxlleiyok5km">
              With the Arsenal
            </p>
            <ul className="mt-5 divide-y divide-night-600" data-id="element-66" data-mp="1r26anzvyypsf">
              {comparisonRows.map(row => <li key={row.with} className="flex items-start gap-3 py-4 first:pt-0 last:pb-0" data-id="element-67" data-mp="fkn1zrzmdumh">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber" aria-hidden="true" data-id="element-68" data-mp="h1srk0x039je" />
                  <span className="text-sm font-medium leading-relaxed text-cream sm:text-base" data-id="element-69" data-mp="gzzfu77j5z4j">
                    {row.with}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}